export default __webpack_public_path__ + "static/media/IMG_5059.0aeac948.png";